export default __webpack_public_path__ + "static/media/regulatory--no-pedestrians--g2.c1cbab61.png";